import { render, staticRenderFns } from "./RoomPowerLevelsChanged.vue?vue&type=template&id=051a0aca&"
import script from "./RoomPowerLevelsChanged.vue?vue&type=script&lang=js&"
export * from "./RoomPowerLevelsChanged.vue?vue&type=script&lang=js&"
import style0 from "./RoomPowerLevelsChanged.vue?vue&type=style&index=0&id=051a0aca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports